import imageCompression from "browser-image-compression";

const MAX_FILE_SIZE_MB = 2.5;

const DEFAULT_IMAGE_COMPRESSION_OPTIONS = {
  maxSizeMB: MAX_FILE_SIZE_MB,
  maxWidthOrHeight: 1920,
  useWebWorker: false,
  fileType: "image/jpeg", // default to jpeg output
};

export const isFileLargerThanMaxSize = (file, maxSizeMB = MAX_FILE_SIZE_MB) => {
  if (!file.size && file.size !== 0) {
    throw new Error("isFileLargerThanMaxSize received a value it can't handle");
  }
  const size = file.size / 1024 / 1024;
  return size > maxSizeMB;
};

export const compressImgToTargetSize = async (
  imageFile,
  options = DEFAULT_IMAGE_COMPRESSION_OPTIONS
) => {
  if (!imageFile.type.includes("image/")) {
    throw new Error("The file given is not an image")
  }
  const compressedFile = await imageCompression(imageFile, options);
  // const origSize = imageFile.size / 1024 / 1024; // holding on to this value as we'll likely want to report some analytics around it
  // const compressedSize = compressedFile.size / 1024 / 1024; // holding on to this value as we'll likely want to report some analytics around it
  return compressedFile;
};

export const compressImgFileIfLargerThanTarget = async (
  imageFile,
  maxSizeMB = MAX_FILE_SIZE_MB
) => {
  let response = imageFile;
  try {
    if (isFileLargerThanMaxSize(imageFile, maxSizeMB)) {
      const options = { ...DEFAULT_IMAGE_COMPRESSION_OPTIONS, maxSizeMB };
      response = await compressImgToTargetSize(imageFile, options);
    }
  } catch {
    response = imageFile;
  }
  return response;
};
